import {AppConfig, DecimalPlacesConfig} from 'appConfig';
import {BUILD_INFO} from '../generated/build-info';

// const allNewsProviders = require('../news-providers'); // TODO: News providers.

const DEFAULT_DECIMAL_PLACES: DecimalPlacesConfig = {price: 4, quantity: 2, report: 3};

const PREDEFINED_WATCHLIST_IDS = {
    BINANCE:         'DEFAULT_PBV6wdX8EC0_86bN8wnpF',
    BINANCE_USA:     'DEFAULT_tmwjsu9amFyCKWPvU0uar',
    BITFINEX:        'DEFAULT_CGZ33eA2t8o0M57lv2d_D',
    COINBASE:        'DEFAULT_Qx2Jmmm8yT54EUXXWlUFu',
    GEMINI:          'DEFAULT_9ktgDgynUyvs2nKAMXAjt',
    HUOBI:           'DEFAULT_Mca4ozKdgBS7Wq8JiHExu',
    OKEX:            'DEFAULT_OBBSnNImTynX0WXQrs4Au',
    OKEX_PERPETUALS: 'DEFAULT_EUBNffW7HZdWdxE2MGqYD',
    OKEX_FUTURES:    'DEFAULT_1pzI5LHcgrWQbd5jVXSGN',
    VOYAGER:         'DEFAULT_gdQgmoOraRFGQxgMXxnuQ',
    KRAKEN:          'DEFAULT_b0osAtefxw6Cq6eb3n4ej',
    BITMEX:          'DEFAULT_y-ZBMVCmEzT98T3I_OUMf'
};

export const defaultConfig: AppConfig = {
    publicPath: '/', // root of the application's URL
    buildInfo: BUILD_INFO,
    api: {
        root: 'https://ci-webtrader.devpool.com/backend',

        echo:               'api/v1/echo',
        login:              'api/v1/auth/login',
        loginByToken:       'api/v1/auth/loginByToken',
        logout:             'api/v1/auth/logout',
        currentUser:        'api/v1/users',
        userList:           'api/v1/users/list',
        changePassword:     'api/v1/users/change-password',
        signUp:             'api/v1/auth/signup',
        registerDemo:       'api/v1/auth/signup/register-demo',
        account:            'api/v1/account',
        accountPermissions: 'api/v1/account-permissions',
        accountAdmin:       'api/v1/account-admin',
        candles:            'api/v1/candles',
        orders:             'api/v1/orders',
        securities:         'api/v1/securities',
        settings:           'api/v1/settings',
        globalSettings:     'api/v1/global-settings',
        layout:             'api/v1/layout',
        news:               './api/news',
        log:                './api/log',

        backofficeEcho:        'api/v1/backoffice/echo',
        backofficeLogin:       'api/v1/backoffice/auth/login',
        backofficeLogout:      'api/v1/backoffice/auth/logout',
        backofficeCurrentUser: 'api/v1/backoffice/users/current_user',
        backofficeAssets:      'api/v1/backoffice/assets',
        backofficeOrders:      'api/v1/backoffice/orders',
        backofficeReports:     'api/v1/backoffice/reports',
        backofficeSecurities:  'api/v1/backoffice/securities',
        backofficeUsers:       'api/v1/backoffice/users',
        backofficeSettings:    'api/v1/backoffice/settings',
        backofficeLayout:      'api/v1/backoffice/layout',

        defaultStreaming: 'api/v1/stream'
    },
    localStorageKeyPrefix: 'web-trader/v2',
    defaultSecurityKey: 'BTC/USD:DVPL:USD',
    defaultWatchlistId: PREDEFINED_WATCHLIST_IDS.BINANCE,
    defaultDecimalPlaces: DEFAULT_DECIMAL_PLACES,
    disableContextMenu: true,
    supportConditionalOrders: true, // [COMMON-1427] It should always be ON.
    newsProviders: [
        'YAHOO_FINANCE',
        'COIN_DESK',
        'CRYPTO_CURRENCY_NEWS',
        'BLOCK'
    ],
    applicationTitle: 'Web Trader',

    /**
     * {@link SignUpFlow}
     */
    signUpFlow: 'SIGN_UP_AND_DEMO',
    resetPasswordFlow: true,
    logoImageUrl: 'images/demo-logo.svg',
    backofficeLogoImageUrl: 'images/backoffice-logo.svg',
    displayExchange: false,
    defaultDayTimeRange: [
        8 * 60 * 60 * 1000, // 08:00 AM
        18 * 60 * 60 * 1000 // 06:00 PM
    ],
    predefinedWatchlistIds: PREDEFINED_WATCHLIST_IDS
};

export default defaultConfig;
